import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { SubscribeButton } from "./SubscribeButton";

export const StickyBar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [footerVisible, setFooterVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 700);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  useEffect(() => {
    const footer = document.querySelector("[data-testid='footer']");
    if (!footer) return;
    const obs = new IntersectionObserver(([entry]) => setFooterVisible(entry.isIntersecting), { threshold: 0.05 });
    obs.observe(footer);
    return () => obs.disconnect();
  }, []);
  const visible = scrolled && !footerVisible;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100 }}
          animate={{ y: 0 }}
          exit={{ y: 100 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          data-testid="sticky-subscribe-bar"
          className="fixed inset-x-0 bottom-0 z-50 border-t border-purple-100 bg-white/90 backdrop-blur-xl"
        >
          <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-5 py-3">
            <div className="hidden sm:block">
              <p className="font-heading text-sm font-bold text-slate-900">MIR-IA Starter Pack</p>
              <p className="text-xs text-slate-500">997€/anno — meno di una cena al mese</p>
            </div>
            <SubscribeButton testid="sticky-subscribe-btn" label="Inizia ora — 997€/anno" small />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
